import { PublicUtilityType } from './device.model';

export interface FieldDeviceEnabledSettingModel {
  enabled: boolean;
}

export interface FieldDeviceTaskSettingsModel {
  deleteAfterReadingDays: number;
  deleteAfterClosingDays: number;
}

export interface FieldDeviceGpsSettingsModel {
  required: boolean;
  coordinateValidityInMinutes: number;
}

/** The backend resolution slots. Following the backend naming, METER is the scale and DEVICE the meter. */
export enum FieldDevicePhotoResolutionKey {
  METER = 'METER',
  DEVICE = 'DEVICE',
  REPORT = 'REPORT',
  NOT_READABLE_CONSUMPTION_PLACE = 'NOT_READABLE_CONSUMPTION_PLACE',
  NOT_READABLE_DEVICE = 'NOT_READABLE_DEVICE',
  NOT_READABLE_METER = 'NOT_READABLE_METER',
  DOCUMENT = 'DOCUMENT',
  HEALTH_AND_SAFETY = 'HEALTH_AND_SAFETY',
}

export interface FieldDevicePhotoResolutionModel {
  width: number;
  height: number;
}

export interface FieldDevicePhotoSettingsModel {
  deleteAfterDays: number;
  minQualityScore: number;
  retryCount: number;
  resolution?: Partial<Record<FieldDevicePhotoResolutionKey, FieldDevicePhotoResolutionModel>>;
}

export interface FieldDeviceUtilitySettingsModel {
  task: FieldDeviceTaskSettingsModel;
  gps: FieldDeviceGpsSettingsModel;
  readingConfirmField: FieldDeviceEnabledSettingModel;
  photo: FieldDevicePhotoSettingsModel;
}

/** One interval for the whole device: the mobile app runs a single periodic sync job. */
export interface FieldDeviceSynchronizationSettingsModel {
  periodicSynchronizationRepeatInMinutes: number;
}

export interface FieldDevicePhotoCountModel {
  min: number;
  max: number;
}

/** Following the backend naming, meterPhotoCount is the scale photo and devicePhotoCount the meter site. */
export interface FieldDeviceReadSettingsModel {
  meterPhotoCount: FieldDevicePhotoCountModel;
  devicePhotoCount: FieldDevicePhotoCountModel;
  keepWithdrawnTaskInDays: number;
}

export interface FieldDeviceCheckSettingsModel {
  meterPhotoCount: FieldDevicePhotoCountModel;
  devicePhotoCount: FieldDevicePhotoCountModel;
  documentPhotoCount: FieldDevicePhotoCountModel;
  keepCompletedTaskInDays: number;
  keepWithdrawnTaskInDays: number;
}

export interface FieldDeviceHealthAndSafetySettingsModel {
  photoCount: FieldDevicePhotoCountModel;
  keepHealthAndSafetiesInDays: number;
}

export interface FieldDeviceAppointmentSettingsModel {
  upcomingAppointmentsTimeframeInMinutes: number;
  upcomingAppointmentsCheckPeriodInMinutes: number;
}

export interface FieldDeviceSettingsModel {
  message: {
    deleteAfterDays: number;
  };
  maintenanceMenu: FieldDeviceEnabledSettingModel;
  gpsTracking: FieldDeviceEnabledSettingModel;
  synchronization: FieldDeviceSynchronizationSettingsModel;
  utilityTypes: Record<PublicUtilityType, FieldDeviceUtilitySettingsModel>;
  read: FieldDeviceReadSettingsModel;
  check: FieldDeviceCheckSettingsModel;
  healthAndSafety: FieldDeviceHealthAndSafetySettingsModel;
  appointment: FieldDeviceAppointmentSettingsModel;
}
